import React from 'react';
import PropTypes from 'prop-types';

import {green200, green500, orange100, orange500, red200, red500} from "assets/jss/main";

import {getScoreLevel} from "views/marketplace/retailer/product/utils/ScoreColorCalculator";

ScoreLevelBars.propTypes = {
    score: PropTypes.number.isRequired,
    size: PropTypes.number
};

const LEVEL_COLORS = {
    0: {filled: red500, dimmed: red200},
    1: {filled: orange500, dimmed: orange100},
    2: {filled: green500, dimmed: green200}
};

const BARS = [
    {x: 0, y: 5, height: 7},
    {x: 4.5, y: 3, height: 9},
    {x: 9, y: 1, height: 11}
];

function ScoreLevelBars({score, size = 12}) {
    const colorLevel = getScoreLevel(score) ?? 0;
    const {filled, dimmed} = LEVEL_COLORS[colorLevel];

    return (
        <svg width={size} height={size} viewBox='0 0 12 12' fill='none'>
            {BARS.map((bar, index) => (
                <rect
                    key={index}
                    x={bar.x}
                    y={bar.y}
                    width={3}
                    height={bar.height}
                    rx={1}
                    fill={index <= colorLevel ? filled : dimmed}
                />
            ))}
        </svg>
    );
}

export default ScoreLevelBars;
